import { MessageEnum } from "@/types";
import { ReactNode } from "react";
import { Trans } from "react-i18next";

export const getMessage = (
  msg: MessageEnum,
  courseStartDate?: string,
  name: string = "Viktor",
): ReactNode => {
  const noStartDate = !courseStartDate || courseStartDate === "Invalid Date";
  switch (msg) {
    case MessageEnum.COURSE_START:
      return (
        <Trans
          className="text-sm"
          i18nKey="home.course.course_start" // optional -> fallbacks to defaults if not provided
          defaults="Your course starts <br/> <bold>{{courseStartDate}}</bold>" // optional defaultValue
          values={{ courseStartDate: !noStartDate ? courseStartDate : "-" }}
          components={{
            br: <br />,
            bold: <b className="font-semibold capitalize" />,
          }}
        />
      );
    case MessageEnum.COURSE_START_1_TO_1:
      return (
        <Trans
          className="text-sm"
          i18nKey="home.course.course_start_1_to_1" // optional -> fallbacks to defaults if not provided
          defaults="Start now to book your 1:1 class with a native speaker!" // optional defaultValue
          values={{ courseStartDate: !noStartDate ? courseStartDate : "-" }}
          components={{
            br: <br />,
            bold: <b className="font-semibold capitalize" />,
          }}
        />
      );
    case MessageEnum.MISSED_LAST_WEEK:
      return (
        <Trans
          className="text-sm font-semibold"
          i18nKey="home.course.missed_last_week" // optional -> fallbacks to defaults if not provided
          defaults="Hey, we lost contact with <br/>you last week. Have you <br/>been abducted by<br/>aliens?"
          components={{ br: <br /> }}
        />
      );
    case MessageEnum.FIRST_WEEK_COMPLETE:
      return (
        <Trans
          className="text-sm font-semibold"
          i18nKey="home.course.first_week_complete" // optional -> fallbacks to defaults if not provided
          defaults="Mission accomplished! You've completed the first week of the course.<br/>Stellar start!" // optional defaultValue
          components={{ italic: <i />, bold: <strong /> }}
        />
      );
    case MessageEnum.RETURN_AFTER_MISSING_WEEK:
      return (
        <Trans
          i18nKey="home.course.return_after_one_week" // optional -> fallbacks to defaults if not provided
          defaults="Houston we had a <br/>problem, you lost a<br/> week of lesson, but <br/> your relaunch is stellar!" // optional defaultValue
          components={{ br: <br /> }}
        />
      );
    case MessageEnum.MONTH_TO_COMPLETION:
      return (
        <Trans
          i18nKey="home.course.month_to_completion" // optional -> fallbacks to defaults if not provided
          defaults="Don't be an Martian to <br/>success! Don't give up,<br/>only left 1 month!" // optional defaultValue
          components={{ br: <br /> }}
        />
      );
    case MessageEnum.COURSE_COMPLETED:
      return (
        <Trans
          i18nKey="home.course.complete" // optional -> fallbacks to defaults if not provided
          defaults="Course completed, amazing work!" // optional defaultValue
          components={{ br: <br /> }}
        />
      );
    default:
      return (
        <Trans
          i18nKey="home.course.default" // optional -> fallbacks to defaults if not provided
          defaults="Let's keep going and boost your English!" // optional defaultValue
          values={{ name: name }}
          components={{ br: <br />, bold: <b className="font-semibold" /> }}
        />
      );
  }
};
